/**
 * Obstruction Details Content
 *
 * Section router mirror of `TaskDetailsContent` — switches between the
 * registered obstruction panel sections (`general`, `contractor`, `history`)
 * for the active tab. Each section is implemented in
 * `src/components/obstructions/panel/<Section>/`.
 */
import type { ReactElement } from 'react';

import { ObstructionGeneralInfo } from '../../panel/ObstructionGeneralInfo';
import { ObstructionContractor } from '../../panel/ObstructionContractor';
import { ObstructionAttachments } from '../../panel/ObstructionAttachments';
import { ObstructionHistory } from '../../panel/ObstructionHistory';
import type { Obstruction } from '@/types/obstructions';
import type { ObstructionDetailTabType } from '../hooks/useObstructionDetailsState';

interface ObstructionDetailsContentProps {
  activeTab: ObstructionDetailTabType;
  obstruction: Obstruction;
}

export function ObstructionDetailsContent({
  activeTab,
  obstruction,
}: ObstructionDetailsContentProps): ReactElement {
  switch (activeTab) {
    case 'contractor':
      return <ObstructionContractor obstruction={obstruction} />;
    case 'attachments':
      return <ObstructionAttachments obstruction={obstruction} />;
    case 'history':
      return <ObstructionHistory obstruction={obstruction} />;
    case 'general':
    default:
      return <ObstructionGeneralInfo obstruction={obstruction} />;
  }
}
